import { FC } from 'react';
import { Button, ButtonProps, CircularProgress } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

interface StyleProps {
  cancel?: boolean;
  ap?: boolean;
}

export interface IOysterButton extends ButtonProps, StyleProps {
  loading?: boolean;
  label?: string;
  disabled?: boolean;
  loaderColor?: string;
}

const useStyles = makeStyles<Theme, StyleProps>((theme) =>
  createStyles({
    root: {
      backgroundColor: ({ cancel }) =>
        !cancel ? theme.oysterTheme.pine : theme.oysterTheme.cotton,
      color: ({ cancel }) => (cancel ? theme.oysterTheme.ferrari : theme.oysterTheme.cotton),
      borderRadius: '8px',
      boxShadow: ({ cancel }) => (cancel ? 'none' : '0px 8px 24px rgba(1, 70, 81, 0.16)'),
      border: ({ cancel }) => (cancel ? '2px solid rgba(249, 90, 89, 0.10)' : '2px solid #014651'),
      fontWeight: 'bold',
      '&:hover': {
        color: theme.oysterTheme.cotton,
        backgroundColor: ({ cancel }) => (cancel ? theme.oysterTheme.ferrari : '#5C838A'),
        border: ({ cancel }) =>
          cancel ? `2px solid ${theme.oysterTheme.ferrari}` : '2px solid #5C838A',
        boxShadow: 'none',
        cursor: 'pointer',
      },
    },
    containedSizeLarge: {
      fontSize: ({ ap }) => (!ap ? '16px' : '18px'),
      lineHeight: '20px',
      padding: '14px 21px',
      minWidth: '266px',
    },
    disabled: {
      border: `2px solid ${theme.oysterTheme.stone} !important`,
      backgroundColor: `${theme.oysterTheme.stone} !important`,
      color: `${theme.oysterTheme.dolphin} !important`,
      boxShadow: 'none',
    },
  }),
);

const OysterButton: FC<IOysterButton> = ({
  cancel = false,
  ap = false,
  variant = 'contained',
  children,
  label,
  loading = false,
  disabled = false,
  loaderColor = '',
  ...restProps
}) => {
  const classes = useStyles({ cancel, ap });

  const ButtonContent = () => {
    if (loading) {
      return <CircularProgress data-testid="pay-button-progress" size={24} />;
    }
    return <>{label ? label : children}</>;
  };

  return (
    <Button disabled={disabled} variant={variant} classes={classes} {...restProps}>
      <ButtonContent />
    </Button>
  );
};

export default OysterButton;
